import Service, { getCallApiFunction } from '../service'
import { TPreference } from '@/types/preference-tag'

type TResponse = {
  tagList: Array<TPreference>
}

class FetchMemberPreferencesTagApi extends Service {
  constructor() {
    super()
    this.name = 'FETCH_MEMBER_PREFERENCES_TAG'

    this.config = {
      url: `/v1/livemall/preferences`,
      method: 'GET',
    }
  }
}

export const fetchMemberPreferencesTag: () => TResponse = () => getCallApiFunction(new FetchMemberPreferencesTagApi())
